import ReviewWidget from './Components/templates/ReviewWidget/index';
import './styles/main.css';
// Function to initialize the widget
var initReviewWidget = function (containerId, config) {
    var container = document.getElementById(containerId);
    if (!container) {
        console.error("Container with ID '".concat(containerId, "' not found"));
        return;
    }
    // Check if React and ReactDOM are available
    if (typeof window === 'undefined' || !window.React || !window.ReactDOM) {
        console.error('React or ReactDOM is not loaded. Please load React and ReactDOM before the widget script.');
        return;
    }
    var React = window.React;
    var ReactDOM = window.ReactDOM;
    // Use createRoot if available (React 18+), otherwise fallback to render (React 17)
    if (ReactDOM.createRoot) {
        var root = ReactDOM.createRoot(container);
        root.render(React.createElement(React.StrictMode, null, React.createElement(ReviewWidget, {
            siteId: config.siteId,
            initialSort: config.initialSort
        })));
    }
    else if (ReactDOM.render) {
        // Fallback for React 17
        ReactDOM.render(React.createElement(React.StrictMode, null, React.createElement(ReviewWidget, {
            siteId: config.siteId,
            initialSort: config.initialSort
        })), container);
    }
    else {
        console.error('ReactDOM.createRoot or ReactDOM.render is not available');
    }
};
// Create the exports object
var reviewWidgetExports = {
    init: initReviewWidget
};
// Export for UMD
export default reviewWidgetExports;
// Assign to window object
if (typeof window !== 'undefined') {
    window.ReviewWidgetInit = initReviewWidget;
    window.ReviewWidget = reviewWidgetExports;
}
